

























import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import moment from 'moment';


export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toSumupScoreAverageList = () => {
      context.root.$router.push(`/teacher_site/sumup_score_average_list/${context.root.$route.params.sheet_group_key}/${context.root.$route.params.subject_id}`);
    };
    
    const toSumupScoreDistributionList = () => {
      context.root.$router.push(`/teacher_site/sumup_score_distribution_list/${context.root.$route.params.sheet_group_key}/${context.root.$route.params.subject_id}`);
    };

    const toSumupMajorNoScoreRateList = () => {
      context.root.$router.push(`/teacher_site/sumup_major_no_score_rate_list/${context.root.$route.params.sheet_group_key}/${context.root.$route.params.subject_id}`);
    };

    const toSumupQuestionScoreRateList = () => {
      context.root.$router.push(`/teacher_site/sumup_question_score_rate_list/${context.root.$route.params.sheet_group_key}/${context.root.$route.params.subject_id}`);
    };

    const toSumupViewPointScoreRateList = () => {
      context.root.$router.push(`/teacher_site/sumup_view_point_score_rate_list/${context.root.$route.params.sheet_group_key}/${context.root.$route.params.subject_id}`);
    };

    const downloadExcel = async () => {
      await http.get(`/api/sumup_score_average_list/download_excel/${context.root.$route.params.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `saiten_result_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });
    };

    return {
      toSumupScoreAverageList,
      toSumupScoreDistributionList,
      toSumupMajorNoScoreRateList,
      toSumupQuestionScoreRateList,
      toSumupViewPointScoreRateList,
      downloadExcel
    };
  }
})
